/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
const Home = ()=>import("@/pages/index")
const Mine = ()=>import("@/pages/mine")
const Course = ()=>import("@/pages/Course/index")
const CourseInfo = ()=>import("@/pages/Course/info")
const User = ()=>import("@/pages/User/index")
const CreateUser = ()=>import("@/pages/User/create")
const GiveCourse = ()=>import("@/pages/User/giveCourse")
const GiveCoupon = ()=>import("@/pages/User/giveCoupon")
const UserCourse = ()=>import("@/pages/User/course")
const UserOrder = ()=>import("@/pages/User/order")
const Order = ()=>import("@/pages/Order/index")
const OrderInfo = ()=>import("@/pages/Order/info")
const OrderChange = ()=>import("@/pages/Order/change")
const Login = ()=>import("@/pages/Login")
const error_401 = ()=>import("@/pages/error401")
const SalesTracking = ()=>import("@/pages/SalesTracking/index")
const SalesTrackingView = ()=>import("@/pages/SalesTracking/view")
const SalesTrackingInfo = ()=>import("@/pages/SalesTracking/info")
const Signup = ()=>import("@/pages/Signup/index")
const SignupView = ()=>import("@/pages/Signup/view")
const SignupInfo = ()=>import("@/pages/Signup/info")
const Feedback = ()=>import("@/pages/Feedback/index")
const Comment = ()=>import("@/pages/Comment/index")
const Coupon = ()=>import("@/pages/Coupon/index")
const Test = ()=>import("@/pages/test")
const Classhour = ()=>import("@/pages/Classhour/index")
const ClasshourQrcode = ()=>import("@/pages/Classhour/qrcode")
const ClasshourSign = ()=>import("@/pages/Classhour/sign")
export default [{
      path: '/',
      name: 'home',
      component: Home,
      meta:{
        title:"首页"
      }
    },
    {
      path: '/mine',
      name: 'other',
      component: Mine,
      meta:{
        title:"其他"
      }
    },
    {
      path: '/course',
      name: 'course',
      component: Course,
      meta:{
        title:"课程"
      }
    }, {
      path: '/course/info',
      name: 'corse-info',
      component: CourseInfo,
      meta:{
        title:"课程详情"
      }
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      meta:{
        title:"用户"
      }
    },
    {
      path: '/user/course',
      name: 'user-course',
      component: UserCourse,
      meta:{
        title:"用户课程"
      }
    },
    {
      path: '/user/order',
      name: 'user-order',
      component: UserOrder,
      meta:{
        title:"用户订单"
      }
    },
    {
      path: '/user/create',
      name: 'user-create',
      component: CreateUser,
      meta:{
        title:"创建用户"
      }
    },
    {
      path: '/user/give-course',
      name: 'give-course',
      component: GiveCourse,
      meta:{
        title:"赠送课程"
      }
    },
    {
      path: '/user/give-coupon',
      name: 'give-coupon',
      component: GiveCoupon,
      meta:{
        title:"赠送优惠券"
      }
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta:{
        title:"订单"
      }
    },
    {
      path: '/order/info',
      name: 'order-info',
      component: OrderInfo,
      meta:{
        title:"订单详情"
      }
    },
    {
      path: '/order/change',
      name: 'order-change',
      component: OrderChange,
      meta:{
        title:"订单改价"
      }
    },
    {
      path: '/sales-tracking',
      name: 'sales-tracking',
      component: SalesTracking,
      meta:{
        title:"跟单管理"
      }
    },
    {
      path: '/sales-tracking/view',
      name: 'sales-tracking-view',
      component: SalesTrackingView,
      meta:{
        title:"跟单管理查看"
      }
    },
    {
      path: '/sales-tracking/info',
      name: 'sales-tracking-info',
      component: SalesTrackingInfo,
      meta:{
        title:"跟单管理编辑"
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta:{
        title:"线下报名"
      }
    },
    {
      path: '/signup/view',
      name: 'signup-view',
      component: SignupView,
      meta:{
        title:"线下报名查看"
      }
    },
    {
      path: '/signup/info',
      name: 'signup-info',
      component: SignupInfo,
      meta:{
        title:"线下报名编辑"
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback,
      meta:{
        title:"用户反馈"
      }
    },
    {
      path: '/comment',
      name: 'comment',
      component: Comment,
      meta:{
        title:"评论管理"
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: Coupon,
      meta:{
        title:"优惠券"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta:{
        title:"登录"
      }
    },
    {
      path: '/error_401',
      name: 'error_401',
      component: error_401,
      meta:{
        title:"401错误"
      }
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      meta:{
        title:"测试"
      }
    },
    {
      path: '/classhour',
      name: 'classhour',
      component: Classhour,
      meta:{
        title:"面授课表"
      }
    },
     {
      path: '/classhour/sign',
      name: '/classhour/sign',
      component: ClasshourSign,
      meta:{
        title:"签到统计"
      }
    },
    {
      path: '/classhour/qrcode',
      name: '/classhour/qrcode',
      component: ClasshourQrcode,
      meta:{
        title:"签到码"
      }
    }
  ]



// WEBPACK FOOTER //
// ./src/router/routers.js